import React from "react"
import PropTypes from "prop-types"
import { CloseIcon } from "../Icons"
import "./DialogBox.css"

function DialogBox({
  title,
  primaryAction,
  primaryActionLabel,
  secondaryAction,
  secondaryActionLabel,
  close,
  children,
  deleteButton,
  hideButton,
  className = "",
  submitButton
}) {
  return (
    <div className={`DialogBox-overlay ${className}`}>
      <div className="DialogBox">
        {title && <h1>{title}</h1>}
        <div className="DialogBox-content">{children}</div>
        <div className="DialogBox-buttons">
          {deleteButton && (
            <div className="Optional-button">{deleteButton}</div>
          )}
          {!hideButton && (
            <>
              {secondaryAction && (
                <button
                  className="DialogBox-secondary"
                  onClick={secondaryAction}
                  type="button"
                >
                  {secondaryActionLabel}
                </button>
              )}
              {submitButton && submitButton}
              {primaryAction && (
                <button
                  className="q-orange"
                  onClick={primaryAction}
                  type="button"
                >
                  {primaryActionLabel}
                </button>
              )}
            </>
          )}
        </div>
        {close && (
          <span className="DialogBox-close" onClick={close}>
            <CloseIcon />
          </span>
        )}
      </div>
    </div>
  )
}

DialogBox.propTypes = {
  title: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryActionLabel: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryActionLabel: PropTypes.string,
  close: PropTypes.func.isRequired,
  hideButton: PropTypes.bool,
  submitButton: PropTypes.object
}

export default DialogBox
